// GlobalContext.js
import { createContext, useState } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // shared variable

  return (
    <GlobalContext.Provider value={{ admin, setAdmin }}>
      {children}
    </GlobalContext.Provider>
  );
};
